// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__druAk","small":"Panel_small__kp_Pr","blog":"Panel_blog__KFF26"};